import { render, staticRenderFns } from "./rebirthEnabled.vue?vue&type=template&id=306c81dd&scoped=true"
import script from "./rebirthEnabled.vue?vue&type=script&lang=js"
export * from "./rebirthEnabled.vue?vue&type=script&lang=js"
import style0 from "./rebirthEnabled.vue?vue&type=style&index=0&id=306c81dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306c81dd",
  null
  
)

export default component.exports